
// Layout.js

import React from "react";
import { Helmet } from "react-helmet";
import MetaPixelTracker from "./MetaPixelTracker";

const Layout = ({ children }) => {
  // console.log('Layout component rendered');
  const pixelId = process.env.REACT_APP_PIXEL_ID || "805572852127945";
  return (
    <>
      <Helmet>
  <meta
    name="google-site-verification"
    content="YAEybaRuD-pOr9dw2scpS8Ed1NtsXCBFLHdIxVP_Ykk"
  />
  <meta name="google-adsense-account" content="ca-pub-3739622148709879"></meta>
 {/* Google AdSense Code */}
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3739622148709879"
          crossOrigin="anonymous"
        ></script>
  {/* Meta Pixel Code */}
  <script>
    {`
      !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `}
  </script>

  <noscript
    dangerouslySetInnerHTML={{
      __html: `<img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`
    }}
  />
  
</Helmet>

      <MetaPixelTracker />
      {children}
    </>
  );
};

export default Layout;














// // Layout.js

// import React from "react";
// import { Helmet } from "react-helmet";
// import MetaPixelTracker from "./MetaPixelTracker";

// const Layout = ({ children }) => {
//   // console.log('Layout component rendered');
//   const pixelId = process.env.REACT_APP_PIXEL_ID || "805572852127945";
//   return (
//     <>
//       {/* <Helmet>
//         <meta
//           name="google-site-verification"
//           content="YAEybaRuD-pOr9dw2scpS8Ed1NtsXCBFLHdIxVP_Ykk"
//         />

//           <>
//             <script>
//               {`
//                 !function(f,b,e,v,n,t,s)
// {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
// n.callMethod.apply(n,arguments):n.queue.push(arguments)};
// if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
// n.queue=[];t=b.createElement(e);t.async=!0;
// t.src=v;s=b.getElementsByTagName(e)[0];
// s.parentNode.insertBefore(t,s)}(window, document,'script',
// 'https://connect.facebook.net/en_US/fbevents.js');
//                 fbq('init', '${pixelId}');
//                 fbq('track', 'PageView');
//               `}
//             </script>
//             <noscript>
//               {`
//                 <img height="1" width="1" style="display:none"
//                   src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"
//                 />
//               `}
//             </noscript>
//           </>
   
//       </Helmet> */}
//       <Helmet>
//   <meta
//     name="google-site-verification"
//     content="YAEybaRuD-pOr9dw2scpS8Ed1NtsXCBFLHdIxVP_Ykk"
//   />

//   {/* Meta Pixel Code */}
//   <script>
//     {`
//       !function(f,b,e,v,n,t,s)
// {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
// n.callMethod.apply(n,arguments):n.queue.push(arguments)};
// if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
// n.queue=[];t=b.createElement(e);t.async=!0;
// t.src=v;s=b.getElementsByTagName(e)[0];
// s.parentNode.insertBefore(t,s)}(window, document,'script',
// 'https://connect.facebook.net/en_US/fbevents.js');
//       fbq('init', '${pixelId}');
//       fbq('track', 'PageView');
//     `}
//   </script>

//   <noscript
//     dangerouslySetInnerHTML={{
//       __html: `<img height="1" width="1" style="display:none"
//         src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`
//     }}
//   />
  
// </Helmet>

//       <MetaPixelTracker />
//       {children}
//     </>
//   );
// };

// export default Layout;
